import { VillagerScheduleStyles } from './VillagerSchedule.types'

const makeStyles = (): VillagerScheduleStyles => ({
	villagerScheduleContainer: {
		display: 'flex',
		flexDirection: 'column'
	}
})

export default makeStyles
